export default __webpack_public_path__ + "static/media/jumbotron.5c90c69c.png";